export function validationContactForm() {
    const section = document.querySelector(".content-contato");
    if (!section) return;

    const form = section.querySelector("form");
    const inputs = {
        nome: form.querySelector("#nome"),
        email: form.querySelector("#email"),
        assunto: form.querySelector("#assunto"),
        mensagem: form.querySelector("#mensagem"),
    };

    const errors = form.querySelectorAll(".error");

    function isValidEmail(email) {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|com\.br)$/;
        return regex.test(email);
    }

    form.addEventListener("submit", (e) => {
        let hasErrors = false;

        errors.forEach((err) => err.classList.remove("d-block"));
        errors.forEach((err) => err.classList.add("d-none"));

        if (!inputs.nome.value.trim()) {
            showError(inputs.nome);
            hasErrors = true;
        }

        if (!inputs.email.value.trim() || !isValidEmail(inputs.email.value.trim())) {
            showError(inputs.email);
            hasErrors = true;
        }

        if (!inputs.assunto.value.trim()) {
            showError(inputs.assunto);
            hasErrors = true;
        }

        if (!inputs.mensagem.value.trim()) {
            showError(inputs.mensagem);
            hasErrors = true;
        }

        if (hasErrors) {
            e.preventDefault();
        }
    });

    function showError(input) {
        const errorDiv = input.nextElementSibling;
        if (errorDiv && errorDiv.classList.contains("error")) {
            errorDiv.classList.remove("d-none");
            errorDiv.classList.add("d-block");

            input.addEventListener("change", () => {
                errorDiv.classList.remove("d-block");
                errorDiv.classList.add("d-none");
            }, { once: true });
        }
    }
}
